import queryString from "query-string";

import { SET_CURRENT_REQUEST, SET_REQUESTS_LIST, UPDATE_REQUEST_CANCELED, UPDATE_REQUEST_ATTACHMENT, UPDATE_REQUEST_CONFIRMATIONS } from "./types";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getRequest = (requestID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/requests/${requestID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_CURRENT_REQUEST, payload: response.data.request });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getMyRequests = (page, filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/requests/my?${queryString.stringify({ page, ...filters })}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_REQUESTS_LIST, payload: response.data });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getPendingRequests = (scope, page, filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/requests/pending?scope=${scope}&${queryString.stringify({ page, ...filters })}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_REQUESTS_LIST, payload: response.data });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getOtherRequests = (scope, page, filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/requests/other?scope=${scope}&${queryString.stringify({ page, ...filters })}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_REQUESTS_LIST, payload: response.data });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getAllRequests = (scope, page, filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/requests/all?scope=${scope}&${queryString.stringify({ page, ...filters })}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_REQUESTS_LIST, payload: response.data });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const newRequest = (formValues, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/requests`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.push("/requests/my");
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const cancelRequest = (requestID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/requests/cancel/${requestID}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: UPDATE_REQUEST_CANCELED, payload: response.data.request });
            history.go(0);
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const setAttachment = (requestID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/requests/attachment/${requestID}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: UPDATE_REQUEST_ATTACHMENT, payload: response.data.request });
            history.go(0);
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const acceptRequest = (requestID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/requests/answer/${requestID}`, { "accept": true }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: UPDATE_REQUEST_CONFIRMATIONS, payload: response.data.request });
            history.go(0);
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const rejectRequest = (requestID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/requests/answer/${requestID}`, { "accept": false }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: UPDATE_REQUEST_CONFIRMATIONS, payload: response.data.request });
            history.go(0);
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const answerRequest = (token, formValues, onSuccess, onFieldError) => async () => {
    try {
        const response = await backend.patch(`/api/requests/answer/from/${token}`, { ...formValues }, {
            headers: { 
                "Content-Type": "application/json"
            }
        });
        
        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, onFieldError); }
};